<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { Customer } from '../../../../../types/models';
import Toast from '../../../../../services/Toast';
import { api } from '../../../../../api/Api';

const props = defineProps<{
  customers: Customer[]
}>()

const searchQuery = ref('')
const customerList = ref<Customer[]>([])
const endPoint = "revenue/sales/pos/";

defineEmits<{
  (e: 'select', customer: Customer): void
  (e: 'edit', customer: Customer): void
  (e: 'close'): void
}>()

const handleCustomerSearch = async () => {
  if (searchQuery.value.length >= 3) {
    const response = await api.post(endPoint + "customers", {
      search_query: searchQuery.value,
      details: true
  });
  if (response.success == true) {
      customerList.value = response.data;
  } else {
    Toast.show("Could not retrieve customers", "warning");
  }
  }
};

watchEffect(() => {
  customerList.value = props.customers
})


</script>

<template>
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-2xl mx-4">
      <div class="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
        <h3 class="text-lg font-medium text-gray-900 dark:text-white">Select Customer</h3>
        <div class="relative flex-1 max-w-[350px]">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            >🔍</span
          >
          <input
            ref="searchInput"
            v-model="searchQuery"
            type="search"
            placeholder="Search Customers ..."
            @keyup.enter="handleCustomerSearch"
            class="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
          />
        </div>
        <button 
          @click="$emit('close')"
          class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
        >
          ✕
        </button>
      </div>
      
      <div class="p-4 max-h-96 overflow-y-auto">
        <div class="space-y-4">
          <div
        v-for="customer in customerList"
        :key="customer.id ?? ''"
        class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900 rounded-lg"
          >
        <div>
          <h4 class="font-medium text-gray-900 dark:text-white">{{ customer.name }}</h4>              
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ customer.mobile }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ customer.customer_type }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ customer.email }}</p>
        </div>
        <div>
          <button
          @click="$emit('edit', customer)"
          class="px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-lg hover:bg-orange-700"
        >
          Edit
        </button>
        <button
          @click="$emit('select', customer)"
          class="px-4 py-2 ml-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
        >
          Select
        </button>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>